import { makeAutoObservable } from 'mobx'
import { mainStore } from '@/domains/Account/store'
import { apiService } from '@/services/Api'
import { HelpData, HelpType } from '@/services/Api/generated'

export enum ExpertHelpStatus {
  WAIT = 'WAIT',
  SENT = 'SENT',
  EDITED = 'EDITED',
}

export class ExpertHelpStore {
  type: HelpType = HelpType.ModuleHelpWithApplication
  data: HelpData = {}
  phone: string = mainStore.user.phone
  status: ExpertHelpStatus = ExpertHelpStatus.WAIT

  isLoading: boolean = false

  startLoading() {
    this.isLoading = true
  }

  stopLoading() {
    this.isLoading = false
  }

  setData(data: HelpData) {
    this.data = data
  }

  setType(type: HelpType) {
    this.type = type
  }

  setPhone(value: string) {
    this.phone = value
    if (this.status === ExpertHelpStatus.SENT) {
      this.setStatus(ExpertHelpStatus.EDITED)
    }
  }

  setStatus(status: ExpertHelpStatus) {
    this.status = status
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async sendRequest() {
    this.startLoading()
    try {
      const response = await apiService.help.getHelp({
        getHelpRequest: {
          type: this.type,
          data: {
            ...this.data,
            phone: this.phone,
            sourceUrl: window.location.href,
          },
        },
      })
      if (response.status) {
        this.setStatus(ExpertHelpStatus.SENT)
      }
    } finally {
      this.stopLoading()
    }
  }
}
